import { EnterpriseContactThanksPageTemplate } from "@/templates/enterprise/contact-thanks/enterprise-contact-thanks-page/src/enterprise-contact-thanks.template";

export const EnterpriseContactThanksPage = () => (
    <EnterpriseContactThanksPageTemplate />
);
